import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { MdRefresh } from 'react-icons/md';



const Chart = ({ name, data, xaxisCategories, buttonClick }) => {

    const series = data

    const options = {
        colors: ["#c2410c"],
        chart: {
            fontFamily: "Satoshi, sans-serif",
            type: "bar",
            height: 335,
            stacked: false,
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
        },

        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "65%",
                barHeight: "95%",
                borderRadius: 3,
                dataLabels: {
                    position: 'top'
                },
            },
        },

        dataLabels: {
            enabled: true,
            style: {
                fontSize: "14px",
                colors: ["#000000"],
            },
            offsetY: -20,
            formatter: function (val) {
                return val.toString();
            },
        },

        grid: {
            strokeDashArray: 5,
            xaxis: {
                lines: {
                    show: false,
                },
            },
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },

        xaxis: {
            categories: xaxisCategories,
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "14px",
                },
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
            fontFamily: "Satoshi",
            fontWeight: 500,
            fontSize: "14px",
            markers: {
                radius: 99,
                width: 16,
                height: 16,
                strokeWidth: 10,
                strokeColor: "transparent",
            },
        },
        fill: {
            opacity: 1,
        },
    };

    return (
        <div className="col-span-1 rounded-[10px] bg-dark-5/20 px-7.5 pt-7.5 shadow-1 dark:bg-gray-dark dark:shadow-card w-full">
            <div className="mb-4 justify-between items-center gap-2 flex p-2">
                <h4 className="text-body-xl font-bold text-black">
                    {name}
                </h4>
                <button onClick={buttonClick} className='btn px-2 py-1 rounded-lg flex justify-center items-center gap-2 bg-gradient-to-b from-gray-600 to-sky-800 text-white hover:bg-sky-600'>
                    <MdRefresh /> Refresh
                </button>
            </div>

            <div>
                <div id="chart" className="-ml-3.5">
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="bar"
                        height={370}
                    />
                </div>
            </div>
        </div>
    );
};

export default Chart;
